import { render } from "./ChangeStaffRole.vue?vue&type=template&id=1314b27a&scoped=true"
import script from "./ChangeStaffRole.vue?vue&type=script&lang=js"
export * from "./ChangeStaffRole.vue?vue&type=script&lang=js"

import "./ChangeStaffRole.vue?vue&type=style&index=0&id=1314b27a&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1314b27a"]])

export default __exports__